import React, { useEffect } from 'react';
import {interes} from '../../json/interes';
import './interes.css';
import { Link } from 'react-router-dom';

const Interes = () => {  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
	return (
    	<div className='content container transparencia-container container-mh'>
        	<div className='row'>
        		<div className='col_12'>
          			<div className='transparencia_title'>
            			<h1>Interés</h1>
          		</div>
        	</div>
            {
            	interes.map((item, index)=>(
                	item.opcion == 1 ? (
                
	                <Link key={ index } to={ item.url ? item.url : "DetalleRubro/" + item.nombre } className='col-md-4 col-sm-6 col-12 rubro_enlace'>
    		            <div className='rubro_container'>
            			    <div className='new'>
                      			<i className={ `nueva-clase ${item.ico}` }></i>
                    		</div>
                    		<h3 className='tituloSeccion'>{ item.nombre }</h3>
                  		</div>
                	</Link>
                ):(
                	<a href={ item.url } target="_blank" className='col-md-4 col-sm-6 col-12 rubro_enlace'>
                    	<div className='rubro_container'>
                    		<div className='new'>
                      			<i className={ `nueva-clase ${item.ico}` }></i>
                    		</div>
                    		<h3 className='tituloSeccion'>{ item.nombre }</h3>
                  		</div>
                	</a>) 
	            ))
            }
        </div>
    </div>
  )
}

export default Interes